import React, { useState } from "react";
import { Button } from "../components/ui/button";
import { Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const PLANS = [
  { key: "weekly", name: "Settimanale", price: 39.90, badge: "Popolare", features: ["1 box ogni settimana", "Ricette AI incluse", "Cancelli quando vuoi", "Consegna gratuita"] },
  { key: "monthly", name: "Mensile", price: 89.90, badge: null, features: ["1 box ogni mese", "Sconto 15% box regalo", "Priorità novità stagionali", "Consegna gratuita"] },
  { key: "custom", name: "Personalizzato", price: 0, badge: "Flessibile", features: ["Scegli tu la frequenza", "Seleziona le box preferite", "Modifica quando vuoi", "Supporto dedicato"] },
];

export default function Abbonamenti() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(null);

  const subscribe = async (plan) => {
    if (!user) { toast.error("Accedi per sottoscrivere"); nav("/login"); return; }
    setLoading(plan);
    try {
      await api.post("/subscriptions", { plan });
      toast.success("Abbonamento attivato");
    } catch { toast.error("Errore"); } finally { setLoading(null); }
  };

  return (
    <div data-testid="abbonamenti-page" className="container-xl py-12">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">Abbonamenti</div>
      <h1 className="editorial-heading text-5xl md:text-6xl leading-none">Un pezzo d'Italia, ogni settimana</h1>
      <p className="text-muted-foreground text-lg mt-3 max-w-2xl">Piani flessibili per portare a casa tua il meglio dei nostri produttori.</p>
      <div className="mt-10 grid md:grid-cols-3 gap-6">
        {PLANS.map(p => (
          <div key={p.key} data-testid={`plan-${p.key}`} className="border border-border bg-card rounded-sm p-6 hover-lift flex flex-col">
            {p.badge && <div className="chip bg-[hsl(var(--accent))] text-black w-fit">{p.badge}</div>}
            <h3 className="editorial-heading text-3xl mt-3">{p.name}</h3>
            <div className="mt-2 flex items-baseline gap-1">
              {p.price > 0 ? (
                <><span className="text-4xl editorial-heading text-[hsl(var(--primary))]">€{p.price.toFixed(2)}</span><span className="text-sm text-muted-foreground">/{p.key === "weekly" ? "sett" : "mese"}</span></>
              ) : (
                <span className="text-3xl editorial-heading text-[hsl(var(--primary))]">Su misura</span>
              )}
            </div>
            <ul className="mt-6 space-y-2 flex-1">
              {p.features.map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm"><Check className="h-4 w-4 text-[hsl(var(--secondary))] mt-0.5" />{f}</li>
              ))}
            </ul>
            <Button
              data-testid={`plan-cta-${p.key}`}
              onClick={() => subscribe(p.key)}
              disabled={loading === p.key}
              className="mt-6 bg-[hsl(var(--primary))] text-white hover:bg-[hsl(var(--primary))]/90 rounded-sm"
            >
              {loading === p.key ? "Attivazione…" : "Attiva"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
